import { render, staticRenderFns } from "./TimetableTemplateEdit.vue?vue&type=template&id=12d7d2fe"
import script from "@/controllers/custom/timetable_template/timetable-template-edit.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/timetable_template/timetable-template-edit.js?vue&type=script&lang=js&external"
import style0 from "./TimetableTemplateEdit.vue?vue&type=style&index=0&id=12d7d2fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports